export let QuestionType = (function (QuestionType) {
  QuestionType["SINGLE_CHOICE"] = "single_choice";
  QuestionType["SURVEY_MULTIPLE_CHOICE"] = "multiple_choice";
  QuestionType["MULTIPLE_CHOICE"] = "mcq";
  QuestionType["TRUE_FALSE"] = "true_false";
  QuestionType["PARAGRAPH"] = "written";
  QuestionType["FILE_UPLOAD"] = "FILE_UPLOAD";
  return QuestionType;
})({});
